var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHanger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "hanger_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#hanger_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.722 33.333c-.398 0-.729-.132-.993-.395a1.347 1.347 0 0 1-.396-.993c0-.223.047-.429.14-.619.092-.19.23-.354.416-.493L18.61 19.445v-2.5c0-.38.134-.707.403-.98.268-.273.593-.41.972-.41.861 0 1.588-.3 2.18-.902.593-.602.89-1.334.89-2.195 0-.842-.3-1.555-.896-2.138A2.979 2.979 0 0 0 20 9.445c-.843 0-1.562.298-2.16.895a2.943 2.943 0 0 0-.895 2.16h-2.778c0-1.611.57-2.986 1.708-4.125C17.014 7.236 18.389 6.667 20 6.667c1.611 0 2.986.562 4.125 1.687 1.139 1.125 1.708 2.493 1.708 4.104 0 1.343-.414 2.533-1.243 3.57-.828 1.037-1.896 1.75-3.201 2.139v1.278L36.11 30.833c.185.14.324.304.417.493.092.19.139.396.139.619 0 .398-.132.729-.396.992a1.347 1.347 0 0 1-.993.396H4.722Zm4.167-2.778H31.11L20 21.861 8.889 30.555Z"
}))));
export default SvgHanger;